import { Injectable } from '@angular/core';
import { MaskitoOptions} from '@maskito/core'

@Injectable({
  providedIn: 'root'
})
export class MasksService {

  constructor() { }

  readonly numberMask: MaskitoOptions = {
    mask: /^\d+$/
  }

  readonly phoneMask: MaskitoOptions = {
    // mask: ['(','+', /\d/, /\d/,')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]
    mask: /^\+?\d{0,12}$/
  }

  readonly nameMask: MaskitoOptions = {
    mask: /^([^0-9]*)$/
  }

  readonly textMask: MaskitoOptions = {
    mask: /.*/
  }


  getMask(name:string = ''){
    let mask:any = this.textMask;

    if (name === 'phone') {
      mask = this.phoneMask
    } else if (name === 'number') {
      mask = this.numberMask
    } else if (name === 'name') {
      mask = this.nameMask
    }
    return mask
  }
}
